import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    justifyContent: 'flex-end',
    position: 'relative',
    alignItems: 'center',
    flex: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
